<div *ngIf="isPageReady" class="flex flex-col h-full w-full">

  <div class="grow w-full">
    <prox-ag-grid [gridOptions]="gridOptions" [rowData]="notes">
    </prox-ag-grid>
  </div>

  <div class="flex pt-2 pb-2">
    <div class="mr-2">
      <p-button (click)="onOk()" size="small" label="Ok" icon="pi pi-check"></p-button>
      <p-button (click)="onAddNote()" [disabled]="!isEditable" size="small" label="Add Note" icon="pi pi-plus"
        class="ml-2"></p-button>
    </div>
  </div>
</div>